import { z } from "zod";

export enum HomeValueSource {
  ZIP_CODE_AVERAGE = "ZIP_CODE_AVERAGE",
  ZILLOW_HOME_VALUE = "ZILLOW_HOME_VALUE",
}

export const LeadRankScoreSchema = z.object({
  id: z.string(),
  leadRankScore: z.number(),
  leadRank: z.number(),
  homeValueSource: z.nativeEnum(HomeValueSource),

  leadRankConfig: z.object({
    id: z.string(),
    version: z.number(),
    leadRankThreshold: z.number(),

    createdTs: z.string().transform((str) => new Date(str)),
    updatedTs: z.string().transform((str) => new Date(str)),
  }),

  createdTs: z.string().transform((str) => new Date(str)),
  updatedTs: z.string().transform((str) => new Date(str)),
});

export const CustomerLeadSchema = z
  .object({
    yzAnonymousId: z.string().min(1).nullish(),
    email: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    leadSource: z.string().nullish(),
    zipcode: z.string().nullish(),
    score: z.number().nullish(),
    leadScoreVersion: z.number().nullish(),
    leadRankScore: LeadRankScoreSchema.nullish(),
    leadRankScoreId: z.string().nullish(),
    phone: z.string().nullish(),
    leadRank: z.number().nullish(),
    addressLine1: z.string().nullish(),
    addressLine2: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    homeEstimateValue: z.number().nullish(),
    createdTs: z.string().transform((str) => new Date(str)),
    updatedTs: z
      .string()
      .nullish()
      .transform((str) => (str ? new Date(str) : undefined)),
  })
  .strict();

export class InvalidCustomerLeadError extends Error {
  constructor(public errors: z.ZodError) {
    super("Invalid CustomerLead");
    this.name = "InvalidCustomerLeadError";
  }
}

export class EmptyCustomerLeadError extends Error {
  constructor() {
    super("Empty CustomerLead");
    this.name = "EmptyCustomerLeadError";
  }
}
